import { render, staticRenderFns } from "./SourceEnergyScene.vue?vue&type=template&id=057f7a30&scoped=true"
import script from "./SourceEnergyScene.vue?vue&type=script&lang=js"
export * from "./SourceEnergyScene.vue?vue&type=script&lang=js"
import style0 from "./SourceEnergyScene.vue?vue&type=style&index=0&id=057f7a30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057f7a30",
  null
  
)

export default component.exports